
document.addEventListener('DOMContentLoaded', function () {

  function initAlsoLikeSwiper () {
    const el = document.querySelector('.also-like-container .swiper');
    if (!el) return;

    if (el.swiper) return; // 防止重复初始化

    new Swiper(el, {
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: true,
      simulateTouch: true,
      grabCursor: true,
      observer: true,
      observeParents: true
    });

  }

  const observer = new MutationObserver((mutations) => {
    for (let mutation of mutations) {
      if (mutation.addedNodes.length) {
        if (document.querySelector('.also-like-container .swiper')) {
          initAlsoLikeSwiper();
        }
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener("click", function (e) {
  const container = e.target.closest(".also-like-container");
  if (!container) return;

  const minusBtn = e.target.closest(".ajaxcart__qty--minus");
  const plusBtn = e.target.closest(".ajaxcart__qty--plus");

  if (minusBtn || plusBtn) {
    const qtyWrapper = e.target.closest(".ajaxcart__qty");
    if (!qtyWrapper) return;

    const input = qtyWrapper.querySelector(".qty-num");
    if (!input) return;

    let value = Math.max(1, parseInt(input.value) || 1);

    if (plusBtn) input.value = value + 1;
    if (minusBtn) input.value = value > 1 ? value - 1 : 1;

    return;
  }

  const button = e.target.closest(".add-to-cart");
  if (!button) return;

  const product = button.closest(".product");
  if (!product) return;

  const qtyInput = product.querySelector(".qty-num");
  const quantity = Math.max(1, parseInt(qtyInput?.value) || 1);
  const variantId = button.dataset.variantId;

  if (!variantId) return;

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity,
    }),
  }).then(() => {
    window.alsoLikeAdding = true;
    trackAlsoLikeClick($(button), "Add To Cart", "add_to_cart");

    ajaxCart.load();
  });
});

function capitalizeWords (str) {
  return str
    .split(" ") // 按空格分割字符串
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // 转换每个单词
    .join(" "); // 重新组合成字符串
}
function product_page_ga4_deal_with_discount (
  product_item,
  buttom_name,
  event_name,
  discount = 0,
) {
  let $v_item_name = "";
  let $v_item_variant = "";
  let $v_item_category = "";
  let $v_item_category2 = "Standard";
  if (product_handle_map.has(product_item[0])) {
    $v_item_name = product_handle_valueMap[product_item[0]][0];
    $v_item_variant = product_handle_valueMap[product_item[0]][1];
    $v_item_category = product_handle_valueMap[product_item[0]][2];
    $v_item_category2 = product_handle_valueMap[product_item[0]][3];
  }

  let item_list_id = capitalizeWords(product_item[4]);
  let item_list_name = capitalizeWords(product_item[4]);
  if (item_list_id == 'Opendots 2 Listing' || item_list_name == 'Opendots Air Listing') {
    item_list_id = 'bei&lok'
    item_list_name = 'bei&lok'
  }

  let event_parameters_before = {
    item_list_id: item_list_id,
    item_list_name: item_list_name,
    currency: "THB",
    value: Number(product_item[9].split("£").join("").replace(",", "")),
    items: [
      {
        item_id: product_item[0],
        item_name: $v_item_name,
        index: product_item[2],
        item_list_id: item_list_id,
        item_list_name: item_list_name,
        item_category: $v_item_category,
        item_category2: $v_item_category2,
        item_category3: product_item[6].replace("Default Title", "none"),
        item_variant: $v_item_variant,
        item_brand: "SHOKZ",
        price: Number(product_item[9].split("£").join("").replace(",", "")),
        quantity: Number(product_item[10]),
        currency: "THB",
        discount: discount,
      },
    ],
  };

  if (buttom_name) {
    event_parameters_before.button_name = buttom_name;
  }

  window.dataLayer.push({ event_parameters: null });
  window.dataLayer.push({
    event: "ga4Event",
    event_name: event_name,
    event_parameters: event_parameters_before,
  });
}

function trackAlsoLikeClick ($trigger, source, event_name) {
  const $buyCard = $trigger.closest(".also-like-container .product");
  if (!$buyCard.length) return;

  // 产品数据
  let productData =
    $trigger.data("product-data") ||
    $buyCard.find(".product-data-div").data("product-data");

  if (!productData) return;

  const product_item = productData.split("::");

  // 当前价格（不包含对比价）
  const priceText = $buyCard
    .find(".ajaxcart__price")
    .clone()
    .children()
    .remove()
    .end()
    .text()
    .replace(/[^\d.]/g, "");

  // 对比价
  const compareText = $buyCard
    .find(".compare_at_price")
    .text()
    .replace(/[^\d.]/g, "");

  const price = parseFloat(priceText) || 0;
  const compare_at_price = parseFloat(compareText) || 0;

  const discount =
    compare_at_price > price ? +(compare_at_price - price).toFixed(2) : 0;

  // GA4
  product_page_ga4_deal_with_discount(
    product_item,
    source,
    event_name,
    discount,
  );
}

